import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel1 from 'redux-persist/lib/stateReconciler/autoMergeLevel1';
import createSagaMiddleware from 'redux-saga';
import reducers from '../reducer';
import RootSaga from '../saga';
const persistConfig = {
    key: 'root',
    storage,
    // [INC-1880] Profile is persisted by its own nested config in reducer/index.jsx,
    // which excludes `userPermissionList`. blacklist stops root WRITING the slice, but
    // redux-persist never applies it when READING, so the blob earlier builds wrote still
    // carries Profile - stale permissions included - and autoMergeLevel1 would merge it
    // back over the nested config at boot. Drop the slice from the inbound payload too:
    // root no longer owns it.
    blacklist: ['Profile'],
    stateReconciler: (inbound, original, reduced, cfg) => {
        const { Profile, ...rest } = inbound || {};
        return autoMergeLevel1(rest, original, reduced, cfg);
    },
};
const persistedReducer = persistReducer(persistConfig, reducers);
const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];
const configureStore = (initialState) => {
    const store = createStore(persistedReducer, initialState, applyMiddleware(...middlewares));
    sagaMiddleware.run(RootSaga);
    return store;
};
export const store = configureStore();
export const persistor = persistStore(store);
